<template>
  <dashboard-widget title="BOTTLING RATE" :zoomed="zoomed" :width="width" :enableDelete="enableDelete"
                      @zoom="$emit('zoom','DashboardBottlingSummary')"
                      @delete="$emit('delete','DashboardBottlingSummary')"
                      @close="$emit('close')">
    <v-btn-toggle v-model="period" mandatory @change="refresh" style="position:absolute;top:40px;left:10px" :style="zoomed?'top:60px':''">
      <v-btn x-small value="Last30Days">Last 30 days</v-btn>
      <v-btn x-small value="Monthly">This month</v-btn>
    </v-btn-toggle>

    <v-autocomplete :items="[{text:'All',value:'Any'},{text:'> 7% alc./vol.',value:'GT7'},{text:'<= 7% alc./vol.',value:'LE7'}]" v-model="strength" hide-details dense class="text-caption d-inline-block"
              style="position:absolute;top:30px;right:10px;width:100px" :style="zoomed?'top:50px':''" @change="refresh"/>

    <div class="text-center">
      <div ref="chart" class="d-inline-block" :style="zoomed?'height:420px;width:420px;margin-top:35px':'height:245px;width:245px;margin-top:25px'"
            @click="disableTo ? '' : $router.push({name:'ProductionBottling'})"/>
    </div>
  </dashboard-widget>
</template>

<script>
import {format,add} from 'date-fns'

export default {
  name: 'DashboardBottlingSummary',
  props: {
    from: {type:String, required:true},
    to: {type:String, required:true},
    zoomed: {type:Boolean, required:false, default:false},
    width: {type:Number, required:false, default:290},
    enableDelete: {type: Boolean, required:false, default:false},
    disableTo: {type: Boolean, required:false, default:false}
  },
  data() {
    return {
      max: 0,
      dataGauge: null,
      period: 'Last30Days',
      strength: 'Any',

      chart: null,
      options: {minorTicks:5,}
    }
  },
  watch: {
    from() {
      this.refresh();
    },
    to() {
      this.refresh();
    }
  },
  async mounted() {
    if (window.google) {
      window.google.charts.load('current', {'packages':['gauge']});
      window.google.charts.setOnLoadCallback(() => {
        if (this.$refs.chart == undefined)
          return;
        this.chart = new window.google.visualization.Gauge(this.$refs.chart);
        this.refresh();
      });
    }
  },
  methods: {
    async refresh() {
      const results = await this.$apiCall(`query DashboardBottlingSummary($from:Date!, $to:Date!, $period:SummaryPeriod!, $strength:ProductStrength) {
                                            bottlingSummary(from:$from, to:$to, period:$period, strength:$strength) {
                                              totalBottles,periodStart
                                            }
                                          }`, {from:this.from, to:this.to, period:this.period, strength:this.strength});
      if (!results.error) {
        this.max = 0;
        for (const period of results.data.bottlingSummary)
          this.max = this.max > period.totalBottles ? this.max : period.totalBottles;
        this.max = Math.ceil(this.max);
        if (this.max == 0)
          this.max = 1000;

        // Do data for gauge
        let n = results.data.bottlingSummary.length-1;
        if (n !== -1 && results.data.bottlingSummary[n].periodStart < format(add(new Date(), {days:-30}), 'yyyy-MM-dd'))
          n = -1;
        this.dataGauge = [['Label','Value'],['Bottles',n===-1?0:results.data.bottlingSummary[n].totalBottles]];

        this.draw();
      }
    },
    draw() {
      if (this.chart === null)
        return;

      const formatter = new window.google.visualization.NumberFormat({fractionDigits: 0});
      const data = window.google.visualization.arrayToDataTable(this.dataGauge);
      formatter.format(data, 1);

      this.options.max = this.max;
      this.options.greenFrom = .9 * this.options.max;
      this.options.greenTo = this.options.max;
      this.options.yellowFrom = .75 * this.options.max;
      this.options.yellowTo = .9 * this.options.max;

      this.chart.draw(data, this.options);
    }
  }
}
</script>